import React, { createContext, useContext, useState, useRef } from 'react';

const UploadContext = createContext();

export const UploadProvider = ({ children }) => {
  const [uploadProgress, setUploadProgress] = useState(null);
  const [uploadFileName, setUploadFileName] = useState('');
  const [uploadStatus, setUploadStatus] = useState('');
  const [savedUploadState, setSavedUploadState] = useState(null);
  const xhrRef = useRef(null);

  const startUpload = (fileName, uploadState) => {
    setUploadFileName(fileName);
    setUploadProgress(0);
    setUploadStatus('uploading');
    setSavedUploadState(uploadState);
  };

  const updateProgress = (percent) => {
    setUploadProgress(percent);
  };

  const finishUpload = (success) => {
    setUploadStatus(success ? 'done' : 'failed');
    xhrRef.current = null;
    if (success) {
      setTimeout(() => {
        setUploadProgress(null);
        setUploadFileName('');
        setUploadStatus('');
        setSavedUploadState(null);
      }, 3000);
    }
  };

  const cancelUpload = () => {
    if (xhrRef.current) {
      xhrRef.current.abort();
      xhrRef.current = null;
    }
    setUploadProgress(null);
    setUploadFileName('');
    setUploadStatus('');
    setSavedUploadState(null);
  };

  const setXhr = (xhr) => {
    xhrRef.current = xhr;
  };

  return (
    <UploadContext.Provider value={{
      uploadProgress, uploadFileName, uploadStatus,
      savedUploadState, setSavedUploadState,
      startUpload, updateProgress, finishUpload,
      cancelUpload, setXhr
    }}>
      {children}
    </UploadContext.Provider>
  );
};

export const useUpload = () => useContext(UploadContext);